import { requestJson } from './requestJson';

export async function postCreateReviewer(input: {
  testId: string;
  displayName: string | null;
  // `mode` is the regime the SERVER recorded for this reviewer, which is the one
  // that governs both the replay gate and what this client should show. It can
  // differ from the mode on the test fetched at page load if the creator flipped
  // it in between (possible since Cowork020 §2 removed the mode lock).
}): Promise<{ reviewer_id: string; mode: 'blind' | 'live' }> {
  return await requestJson(`/api/tests/${encodeURIComponent(input.testId)}/reviewers`, {
    method: 'POST',
    body: JSON.stringify({
      display_name: input.displayName,
      user_agent: navigator.userAgent,
      viewport: `${window.innerWidth}x${window.innerHeight}`
    })
  });
}
